class CustomError extends Error {
  constructor(message, data, name = 'Custom Error') {
    super(message);
    this.name = name; // Custom name for the error
    this.data = data; // Custom data property
  }
}

export default CustomError